import { render, staticRenderFns } from "./CollaborationNewFunctionGuide.vue?vue&type=template&id=b36de08e&scoped=true&"
import script from "./CollaborationNewFunctionGuide.vue?vue&type=script&lang=ts&"
export * from "./CollaborationNewFunctionGuide.vue?vue&type=script&lang=ts&"
import style0 from "./CollaborationNewFunctionGuide.vue?vue&type=style&index=0&id=b36de08e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36de08e",
  null
  
)

export default component.exports